import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { notify } from '../../../toaster';

export const useBackToDocument = () => {
  const intl = useIntl();
  const { push } = useHistory();
  const location = useLocation();

  const clearToast = () => toast.dismiss('back-to-document');
  const goBackToDocument = () => {
    push(location);
    clearToast();
  };

  const triggerToast = () => {
    notify.default(
      {
        title: intl.formatMessage({
          id: 'features.backToDocument.labels.document',
        }),
        onClose: clearToast,
        toastActions: [
          {
            label: intl.formatMessage({
              id: 'features.backToDocument.returnBack',
            }),
            onClick: goBackToDocument,
            dataTestId: 'back-to-document-return-back-button',
          },
        ],
      },
      { id: 'back-to-document', duration: Infinity }
    );
  };

  return {
    triggerBackToDocumentToast: triggerToast,
    clearBackToDocumentToast: clearToast,
  };
};
